import SecureLinkEmpty from './SecureLinkEmpty.component';

export default SecureLinkEmpty;